/* istanbul ignore file */
import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { putInStorage, isLocationDataAvailable, updateInStorage } from '../../utils/get-location/location-from-storage';
import './OnBoarding.css';
import styles from './Onboarding.module.css';
import { getWorkflow, getSurveyResult, getUserProfile, raiseGAEvent, clearMemoizedWorkflow } from '../../utils/network';
import QuestionCard from './QuestionCard';
import ChatBot from '../ChatBot/ChatBot';
import { languageForApi } from '../../utils/network';
import {
  addLocationQuestion, questionId, isLocationQuestion, addlProfileQuestion,
  nextQuestionId, questionById, setAnswer,
  preFillInitialQuestions, formatAnswers, getComputeRisk, responseForPosting, getUserId, deleteQuestionIdsFromSessionStorage
} from './utils';
import {
  ess, recordEssParams
} from './ess';
import config from '../../config.json';
import {
  parseQueryString, isDesktopScreen, logError,
  appStorage
} from '../../utils/utils';
import useTranslation from '../../hooks/use-translation';
import useLoader from '../../hooks/use-loader';
import { getLocationCoordinates } from '../../utils/get-location';
import Error from '../Commons/error';
import { fireNoChangeEvent, fireQuickSurveyWithNoChangeEvent } from '../../utils/events';
import getSource from '../../utils/get-source';
import * as _ from 'lodash';
import { covid_survey_v5, covid_survey_v4 } from '../OnboardingWrapper/index';
import { useAppState } from '../../contexts/appState';

const inlineStyles = {
  desktopContainer: {
    questionnaire: {
      width: '35em',
      alignContent: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    chatbot: {
      width: '40em',
      alignContent: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
    }
  },
  mobileContainer: {
    questionnaire: {
      width: '100%'
    },
    chatbot: {
      display: 'flex',
      flex: '1',
      flexDirection: 'column',
      width: '95vw'
    }
  }
}

const getSourceId = async () => {
  const { source_id } = parseQueryString();
  if (source_id) {
    return Promise.resolve(source_id);
  }
  const sourceData = await getSource();
  return sourceData.source_id;
}

export default ({ not_override_workflow_id = false, prefer_app_store = false, padding_top_small = false, clear_workflow = false, hideSurveyButton = () => { } }) => {
  const [state, setState] = useState({
    allQuestions: [],
    questions: [],
    isLoading: false,
    workflow_id: null,
    actionName: 'NONE',
    userProfileData: {},
    isNoChangeMessageView: false,
    renderedQuestions: [],
    sourceId: undefined,
    skip_compute_risk: false,
    survey_end_message: "Thank You for taking survey"
  });
  const [{ hideHamburger }, dispatch] = useAppState()
  const { t, language, hasChatBotQuestionnaire } = useTranslation();
  const { showLoading, hideLoading } = useLoader();
  const { questionId: currentQuestionId } = useParams();
  const history = useHistory();
  useEffect(recordEssParams, []);
  const hasUserData = ({ primary_guru_user_relation = 'self', gender, age }) => (!!primary_guru_user_relation && !!gender && !!age);
  const hasUserDataJhh = ({ relation, gender, age }) => (!!relation && !!gender && !!age);
  const hasUserDataMyJio = ({ source_relation, source_gender, source_age_years }) => (!!source_relation && !!source_gender && !!source_age_years);
  const canPreansQuestions = (params) => {
    const { location = {} } = history;
    const { state = {} } = location;
    if (params.no_change === undefined) {
      if (params.source_id === 'JioHealthHub') {
        return hasUserDataJhh(params)
      }
      if (params.source_id === 'JhhWebApp') {
        return hasUserDataJhh(params)
      }
      if (params.source_id === 'MyJio') {
        return hasUserDataMyJio(params)
      }
      return (ess().isFromEss || hasUserData(state));
    }
    return false;
  };
  const getDataForPreliminaryQuestions = (params) => {
    const { location = {} } = history;
    const { state = {} } = location;
    if (ess().isFromEss) {
      return {
        relation: ess().eventData.source_relation,
        gender: ess().eventData.source_gender,
        age: parseInt(ess().eventData.source_age_years, 10)
      };
    }
    else if (params.source_id === "JioHealthHub") {
      return {
        relation: params.relation,
        gender: params.gender,
        age: parseInt(params.age, 10),
      };
    }

    else if (params.source_id === "JhhWebApp") {
      return {
        relation: params.relation,
        gender: params.gender,
        age: parseInt(params.age, 10),
      };
    }

    else if (params.source_id === "MyJio") {
      return {
        relation: params.source_relation,
        gender: params.source_gender,
        age: parseInt(params.source_age_years, 10),
      };
    }
    return {
      relation: state.primary_guru_user_relation,
      gender: state.gender,
      age: parseInt(state.age, 10)
    };
  };

  useEffect(() => {
    (async () => {
      showLoading();
      const sourceId = await getSourceId()
      setState(state => ({
        ...state,
        sourceId
      }));
      try {
        const { flow = '' } = parseQueryString();
        const { hideHamburgerFromHeader } = parseQueryString();
        if (!hideHamburger && hideHamburgerFromHeader) {
          dispatch({ type: 'UPDATE_HAMBURGER_MENU_STATUS', menuStatus: true })
        }
        let userData = null;
        const { location = {} } = history;
        const { state: routeState = {} } = location;
        let questionsForDisplay = [];
        getLocationCoordinates();
        const params = parseQueryString();

        if (ess().isFromEss && !ess().surveyResults && params.workflow_id === "covid_survey_v2") {
          // saveSurveyResults(surveyData);
          if (ess().isNoChangeFromESS) {
            const surveyData = await getSurveyResult();
            const params = parseQueryString();
            if (surveyData.workflow_id !== params.workflow_id) {
              setState(state => ({
                ...state, isLoading: false, actionName: 'MISMATCH_WORKFLOW'
              }));
            } else {
              setState(state => ({ ...state, isLoading: true, actionName: 'NO_CHANGE_UNABLE_TO_CLOSE' }));
              await fireNoChangeEvent(ess().eventData);
            }
            setState(state => ({ ...state, isLoading: false }));
            hideLoading();
            return;
          }
        }
        //resetting workflow id: required because general-workflow also stores a workflow_id
        if (params.workflow_id && !not_override_workflow_id) {
          appStorage.setItem('workflow_id', params.workflow_id);
        }
        if (clear_workflow) {
          clearMemoizedWorkflow(`global-["${language}",${prefer_app_store}]`);
        }
        const { worflow_template: questionsFromWorkflow, workflow_id, skip_compute_risk = false, survey_result_parameter } = await getWorkflow(language, prefer_app_store);
        if (ess().isFromEss) {
          questionsForDisplay = addLocationQuestion(t('C_LOCATION_QUESTION'), questionsFromWorkflow);
        } else if ((flow === 'profileskip')) {
          if (!routeState.guru_user_id) {
            userData = await getUserProfile();
            questionsForDisplay = addlProfileQuestion(t('C_PROFILE_QUESTION'), questionsFromWorkflow, userData);
          } else {
            questionsForDisplay = questionsFromWorkflow;
          }
        } else {
          questionsForDisplay = questionsFromWorkflow;
        }
        let currentQuestion
        if (!hasChatBotQuestionnaire())
          currentQuestion = questionById(currentQuestionId, questionsForDisplay);

        else if (state.renderedQuestions.length == 0) {
          currentQuestion = questionById(currentQuestionId, questionsForDisplay);
        }
        else
          currentQuestion = questionById(state.currentQuestion.question_id, questionsForDisplay);

        await setState(state => {
          const renderedQuestions = questionsForDisplay.slice().splice(0, state.renderedQuestions.length - 1);
          return ({
            ...state,
            isLoading: false,
            allQuestions: questionsFromWorkflow,
            questions: questionsForDisplay,
            workflow_id,
            userProfileData: userData,
            currentQuestion,
            renderedQuestions: [...renderedQuestions, currentQuestion],
            skip_compute_risk,
            survey_end_message: _.get(survey_result_parameter, 'value', (t('THANK_YOU') || "Thank You for taking survey"))
          })
        });

        if (!currentQuestionId || (currentQuestionId === 'cq1') || (currentQuestionId === 'cq2')) {
          const skipPreliminaryQuestions = canPreansQuestions(params);
          const firstQuestionId = questionId(questionsForDisplay[skipPreliminaryQuestions ? 3 : 0]);
          const urlParams = new URLSearchParams(window.location.search);
          if ((flow === 'profileskip') && routeState.guru_user_id) {
            urlParams.set('uid', routeState.guru_user_id);
          }
          if (skipPreliminaryQuestions) {
            urlParams.set('s', preFillInitialQuestions(questionsFromWorkflow, getDataForPreliminaryQuestions(params)));
          }
          history.replace(`/workflow/${firstQuestionId}?${urlParams.toString()}`, routeState);

        }
      } catch (e) {
        logError(e);
        setState(state => ({
          ...state, isLoading: false, error: true
        }));
      }
      hideLoading();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  useEffect(() => {

    function gtag() { window.dataLayer.push(arguments); }
    gtag('event', 'page_view', {
      page_title: 'Symptom Checker',
      page_location: '/workflow',
      page_path: window.location.pathname,
      page_referrer: 'https://healthhub.jio.com'
    });

    if (!appStorage.getItem("gaEventScInit")) {
      getSourceId()
        .then(sourceId => {
          raiseGAEvent(config.gaEcSymptomChecker, config.gaEaInitiated, sourceId)
        })
      appStorage.setItem("gaEventScInit", true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onAnswerSelected = question => selectedAnswer => async () => {
    const { flow = '' } = parseQueryString();
    if (selectedAnswer.id) {
      updateInStorage(question.question_id, selectedAnswer.id);
    } else if (Array.isArray(selectedAnswer)) {
      updateInStorage(question.question_id, selectedAnswer);
    }
    if (selectedAnswer.current ? selectedAnswer.current.length === 0 : Object.entries(selectedAnswer).length === 0) {
      alert(t('QUESTION_ANSWERING_ADVISE'));
      return;
    }
    if (ess().isFromEss && isLocationQuestion(question) && !isLocationDataAvailable()) {
      alert(t('LOCATION_ERROR'));
      return;
    }


    if (flow === 'profileskip' && selectedAnswer.guru_user_id) {
      const firstQuestionId = questionId(state.allQuestions[3]);
      const urlParams = new URLSearchParams(window.location.search);
      const preliminaryAnswers = {
        relation: (selectedAnswer.primary_guru_user_relation || 'self'),
        gender: selectedAnswer.gender,
        age: selectedAnswer.age
      };
      urlParams.set('s', preFillInitialQuestions(state.allQuestions, preliminaryAnswers));
      urlParams.set('uid', selectedAnswer.id);
      history.replace(`/workflow/${firstQuestionId}?${urlParams.toString()}`);
      return;
    }
    const stateString = setAnswer(questionId(question), formatAnswers(selectedAnswer), parseQueryString().s);
    const nextQuestion = nextQuestionId(questionId(question), state.questions);
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('s', stateString);

    if (nextQuestion) {
      if (hasChatBotQuestionnaire()) {
        const questionToAppend = questionById(nextQuestion, state.questions);
        setState(state => ({ ...state, currentQuestion: questionToAppend, renderedQuestions: [...state.renderedQuestions, questionToAppend] }));
      } else history.push(`/workflow/${nextQuestion}?${urlParams.toString()}`);
    } else {
      hideSurveyButton();
      // eslint-disable-next-line no-lonely-if
      if (hasChatBotQuestionnaire()) {
        let questionToAppend = { loading: true };
        setState(state => ({ ...state, renderedQuestions: [...state.renderedQuestions, questionToAppend] }));

        if (ess().isNoChangeFromESS) {
          const newRenderedQuestions = state.renderedQuestions.filter(question => !question.loading);
          newRenderedQuestions.push("");
          setState(state => ({ ...state, currentQuestion: null, renderedQuestions: newRenderedQuestions }));
          await createNoChangeEvent(state);
        }
        else {
          const prefer_app_store = (state.workflow_id === covid_survey_v5 || state.workflow_id === covid_survey_v4);
          const results = await getComputeRisk(language, state.sourceId, state.skip_compute_risk, prefer_app_store);
          const newRenderedQuestions = state.renderedQuestions.filter(question => !question.loading);
          if (!state.skip_compute_risk)
            newRenderedQuestions.push(results);
          else
            newRenderedQuestions.push("");
          setState(state => ({ ...state, currentQuestion: null, renderedQuestions: newRenderedQuestions }));
        }
      }
      else {
        if (ess().isNoChangeFromESS) {
          setState(state => ({ ...state, isLoading: true, actionName: 'NO_CHANGE_UNABLE_TO_CLOSE' }));
          await createNoChangeEvent(state);
          renderMessageView(t, state.actionName === 'MISMATCH_WORKFLOW');
          setState(state => ({ ...state, isLoading: false }));
          hideLoading();
        } else {
          appStorage.removeItem('getComputedRisk');
          appStorage.removeItem('fireSurveyResultEvent');
          history.replace('/');
          history.push(`/workflow/results?${urlParams.toString()}`);
        }
      }
    }
  };

  if (state.isLoading) return <div />;

  if (state.error) return <Error handleRetry={() => history.push('/')} />;
  const styleClassForHeader = ((state.sourceId && (state.sourceId === 'JioHealthHub' || state.sourceId === 'MyJio' || state.sourceId === "JhhWebApp")) || padding_top_small) ? styles.paddingTopSmall : '';
  return (
    <>
      <div className={`${styles.container} ${styleClassForHeader}`}>
        <div>{state.actionName === 'NONE' ? loadQuestionView(t, currentQuestionId, state, onAnswerSelected, hasChatBotQuestionnaire)
          : renderMessageView(t, state.actionName === 'MISMATCH_WORKFLOW')}</div>
      </div>
    </>
  );
};
async function createNoChangeEvent(state) {
  const userId = await getUserId();
  const params = parseQueryString();
  const workflowResponse = {
    "language": languageForApi(state.language),
    "source_id": params.source_id,
    "source_user_id": userId,
    "workflow_id": state.workflow_id,
    "workflow_responses": responseForPosting(state.questions)
  };

  await fireQuickSurveyWithNoChangeEvent(state.language, workflowResponse, ess().eventData);

  deleteQuestionIdsFromSessionStorage(state.questions);
}

function renderMessageView(t, isWorkflowMismatchIssue) {
  return (
    <div>
      <div style={{
        display: 'flex', flexFlow: 'column', alignSelf: 'center'
      }}
      >
        {isWorkflowMismatchIssue ? t('WORKFLOW_ID_MISMATCH') : t('NO_CHANGE_UNABLE_TO_CLOSE')}
      </div>
      <Button
        style={{
          marginTop: '30px', width: '70px', height: '35px', alignSelf: 'center'
        }}
        onClick={() => window.close()}
        variant="contained"
        color="primary"
      >
        {t('DONE')}
      </Button>
    </div>
  );
}
export const renderQuestionCard = (t, currentQuestionId, state, onAnswerSelected, hasChatBotQuestionnaire) => {
  if (hasChatBotQuestionnaire() && state.renderedQuestions.length > 0) {
    return <ChatBot sourceId={state.sourceId} question={state.currentQuestion} questions={state.renderedQuestions} onAnswerSelected={onAnswerSelected(state.currentQuestion)} isNoChange={ess().isNoChangeFromESS} noComputeRiskResponse={state.skip_compute_risk} surveyEndMessage={state.survey_end_message} workflowId={state.workflow_id} />
  }
  if (!hasChatBotQuestionnaire() && currentQuestionId) {
    return <QuestionCard question={questionById(currentQuestionId, state.questions)} enabled={!state.isLoading} onAnswerSelected={onAnswerSelected(questionById(currentQuestionId, state.questions))} />
  }
  return null;
}

function loadQuestionView(t, currentQuestionId, state, onAnswerSelected, hasChatBotQuestionnaire) {
  const displayType = hasChatBotQuestionnaire() ? 'chatbot' : 'questionnaire';
  return (
    <div style={isDesktopScreen() ? inlineStyles.desktopContainer[displayType] : inlineStyles.mobileContainer[displayType]}>
     {!state.isLoading && (
        <>
          <div className={styles.title}>{t('SYMPTOM_CHECKER_TITLE')}</div>
          <div className={styles.subtitle}>
             {t('QUESTION_ANSWERING_ADVISE')}
          </div>
        </>
      )}
      {renderQuestionCard(t, currentQuestionId, state, onAnswerSelected, hasChatBotQuestionnaire)}
    </div>
  );
}

